import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {AverageBallCalculation} from '../../../../model/edu-info/enroll-attestat-average-calculation';
import {EnrollApplicationService} from '../../../../../../common-main/services/enroll-application.service';

@Component({
  selector: 'app-attestat-ball-calaulate-dialog',
  templateUrl: './attestat-ball-calaulate-dialog.component.html',
  styleUrls: ['./attestat-ball-calaulate-dialog.component.scss']
})
export class AttestatBallCalaulateDialogComponent implements OnInit {

  averageBallCalculation = new AverageBallCalculation();

  constructor(private _enrollApplicationService: EnrollApplicationService,
              public dialogRef: MatDialogRef<AttestatBallCalaulateDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data && data.enrollId > 0) {
      this.averageBallCalculation = data;
    }
  }

  ngOnInit() {
  }

  close(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.data && this.data.enrollId > 0) {
      this.logAverageBallCalculationByEnrollId();
    }
    this.dialogRef.close(this.averageBallCalculation);
  }

  calc(fives: number, fours: number, thirds: number) {
    this.averageBallCalculation.average = Math.round((fives * 5 + fours * 4 + thirds * 3) / (fives + fours + thirds) * 100) / 100;
  }

  private logAverageBallCalculationByEnrollId() {
    this.averageBallCalculation.enrollId = this.data.enrollId;
    this._enrollApplicationService.logAverageBallCalculationByEnrollId(this.averageBallCalculation).subscribe(res => {
      console.log(res);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/tabs/enroll-edu-info/attestat-ball-calaulate-dialog/attestat-ball-calaulate-dialog.component.ts